// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3qHCG","icon":"SortAdornment_icon__2bGNr","up":"SortAdornment_up__35Qm6","down":"SortAdornment_down__CBdVM","active":"SortAdornment_active__1JLCY"};